import React, { useState, useEffect } from "react";
import CategoryCard, { CategoryQuestion } from "./CategoryCard";
import styles from "./CategoryQuestionsWrapper.module.css";

interface CategoryQuestionsWrapperProps {
    intro?: string;
    questions: CategoryQuestion[];
    conclusion?: string;
    onAnswersUpdate?: (formattedAnswer: string) => void; // Real-time updates on selection changes
    clearTriggerId?: number; // When this changes, clear all answers
}

export const CategoryQuestionsWrapper: React.FC<CategoryQuestionsWrapperProps> = ({ intro, questions, conclusion, onAnswersUpdate, clearTriggerId }) => {
    // Maintain answers for each question by its index
    const [answers, setAnswers] = useState<{ [key: number]: string[] }>({});

    // Handle clear trigger from parent
    useEffect(() => {
        if (clearTriggerId !== undefined && clearTriggerId > 0) {
            setAnswers({});
            if (onAnswersUpdate) {
                onAnswersUpdate("");
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clearTriggerId]); // Only depend on clearTriggerId, not onAnswersUpdate

    const handleAnswerChange = (index: number, selected: string[]) => {
        setAnswers(prev => {
            const newAnswers = { ...prev, [index]: selected };

            // Notify parent of answer updates in real-time
            if (onAnswersUpdate) {
                const formattedAnswers = questions
                    .map((q, idx) => {
                        const selectedItems = newAnswers[idx];
                        if (selectedItems && selectedItems.length > 0) {
                            return `${q.question}: '${selectedItems.join("', '")}'`;
                        }
                        return null;
                    })
                    .filter(Boolean)
                    .join("\n");

                onAnswersUpdate(formattedAnswers);
            }

            return newAnswers;
        });
    };

    return (
        <div className={styles.wrapper}>
            {intro && <div className={styles.intro}>{intro}</div>}
            {questions.map((q, index) => (
                <CategoryCard key={`wrapper-q-${index}`} questionObj={q} onAnswerChange={selected => handleAnswerChange(index, selected)} clearTriggerId={clearTriggerId} />
            ))}
            {conclusion && <div className={styles.conclusion}>{conclusion}</div>}
        </div>
    );
};

export default CategoryQuestionsWrapper;
